module.exports = __webpack_public_path__ + "static/media/trailer_gray.4162d042.svg";